/**
 * One key family for everything that reads the exportir master, so an import
 * on the Master page invalidates an open PEB draft's lookup too. Kept in its
 * own module so the live-sync helper can use it without the HTTP layer.
 */
export const eksportirKeys = {
  all: ['master', 'eksportirs'] as const,
  list: (params: Record<string, unknown>) => ['master', 'eksportirs', 'list', params] as const,
  /** Super-admin cross-PPJK list. Under `all`, so any exportir write refreshes it too. */
  global: (params: Record<string, unknown>) => ['master', 'eksportirs', 'global', params] as const,
  /** Keyed by the canonical (type, number) pair: a KTP and an NPWP can share 16 digits. */
  lookup: (kodeJenisIdentitas: string, nomorIdentitas: string) =>
    ['master', 'eksportirs', 'lookup', kodeJenisIdentitas, nomorIdentitas] as const,
};
